import React, { FC } from 'react';
import { Flex, Button } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  onSelectAll?: () => void;
  onDeselectAll?: () => void;
  isAllSelected?: boolean;
}

const SelectAllButton: FC<Props> = ({
  onSelectAll,
  onDeselectAll,
  isAllSelected,
}) => {
  const { t } = useTranslation();

  return (
    <Flex justify="flex-end" gridColumn="1/-1">
      <Button
        variant="link"
        onClick={isAllSelected ? onDeselectAll : onSelectAll}
      >
        {isAllSelected ? t('Deselect all') : t('Select all')}
      </Button>
    </Flex>
  );
};

export default SelectAllButton;
